const normalizeText = (value?: string | null) =>
  String(value ?? '')
    .toLowerCase()
    .replace(/ё/g, 'е')
    .replace(/\s+/g, ' ')
    .trim();

// Временная проверка площадки для mobile PNG background.
// Нужна, чтобы ограничить текущий hotfix только Мегаспортом,
// пока background не станет частью нормального контракта ресурсов схемы.
export const isMegasportVenue = ({
  hallName,
  address,
}: {
  hallName?: string | null;
  address?: string | null;
}) => {
  const normalizedHallName = normalizeText(hallName);
  const normalizedAddress = normalizeText(address);

  const hasMegasportName =
    normalizedHallName.includes('мегаспорт') ||
    normalizedHallName.includes('дс мегаспорт');
  const hasMegasportAddress =
    normalizedAddress.includes('ходынский бульвар') && normalizedAddress.includes('дом 3');

  return hasMegasportName && hasMegasportAddress;
};
